<template>
  <div>
    <myHeader />
    <div class="backgro">
      <div class="posi">
        <!-- <p><img src="https://download.hecoos.com/enlightv/2025-16/132418bbc1795b124de4f4aae0ebcf7a.PNG" style="width:65%"></p> -->
        <div class="flowing-gradient-text">hecoos</div>
        <h3
          style="
            font-size: 33px;
            font-family: YourFontName4;
            margin: 5px 0;
            color: white;
          "
        >
          你的创意合作伙伴!
        </h3>
      </div>
    </div>
    <!-- 文化产业的科技平台 -->
    <div class="backgro1">
      <div>
        <div class="posi">
          <p>
            全球领先的全域制作平台，凭借视频播控、灯光预编程、互动体验、机械控制、虚拟制作等核心能力，为影视虚拟制片、展览演艺、艺术装置、品牌发布会等场景提供全链路数字化解决方案。目前，hecoos已服务全球1,000+场高规格项目，曾深度参与《2022北京冬奥会开幕式》等国际顶级舞台，以及赋能深圳卫视虚拟拍摄影棚，打造全流程虚拟制播工作流程，持续用技术贯通艺术创意与最终呈现，为创作者带来高效、精准的制作体验，让精彩直达每一帧画面。
          </p>
        </div>
      </div>
    </div>

    <!-- 文化数字化的新引擎 -->
    <div class="backgro2">
      <div>
        <div class="posi">
          <h3
            style="
              text-align: center;
              color: white;
              padding-bottom: 20px;
              font-size: 26px;
            "
            class="posi_h3"
          >
            文化数字化的新引擎
          </h3>
          <p>
            北京澜景科技以“文化数字化的新引擎”为公司定位，专注于数字媒体软件与互联网产品的研发，为会展、文旅、传媒、教育等行业提供数字化工具产品，并逐步构建覆盖展演仿真、播控系统、虚拟制作、ERP系统的全链条技术生态。其中，Hirender与hecoos媒体服务器以“北京冬奥会开闭幕式”、“杭州亚运会开闭幕式”以及“大阪世博会”等世界级展演活动执行案例为标杆，持续服务于全球各项大型展演活动；澜精灵ERP系统驱动设备租赁、系统集成与文化运营类企业实现全流程数字化升级；深澜空间作为公司旗下的数字艺术示范空间，聚合艺术家、工程师与文化行业从业者共同探索数字时代的文化新表达。创立发展的10年间，澜景以前沿数字技术为内核，不断用创新推动数字科技与文化产业的共生演进。
          </p>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div class="clearfix" id="CallMe">
      <div class="left">
        <div class="app">
          <h1 class="title" style="font-size: 26px">联系我们</h1>
          <p class="description">
            请将您的需求发给我们，我们将仔细阅读您的留言，并与您取得联系。
          </p>
          <div
            v-for="(contact, index) in contactInfos"
            :key="index"
            class="contact-item"
          >
            <span class="ssssss">{{ contact.type }}</span>
            <span class="s1">{{ contact.value }}</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="formtest">
          <div class="form-group">
            <input
              type="text"
              v-model="formData.name"
              placeholder="你的姓名"
              class="form-input"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model="formData.email"
              placeholder="邮箱地址"
              class="form-input"
            />
          </div>
          <div class="form-group">
            <textarea
              v-model="formData.content"
              placeholder="留言"
              class="form-textarea"
            ></textarea>
            <div class="button-container">
              <button class="send-button1" @click="handleSubmit">
                确认发送
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 加入我们 -->
<!--    <div class="padd">-->
<!--      <div class="job-list-container">-->
<!--        <h1 class="" style="color: white; font-size: 26px">加入我们</h1>-->
<!--        <p class="" style="color: white">欢迎投置简历至:hr@enlightv.com</p>-->
<!--        <div class="filter-section">-->
<!--          <select v-model="selectedCategory">-->
<!--            <option value="all">全部岗位</option>-->
<!--            &lt;!&ndash; <option value="category1">岗位类别1</option>-->
<!--              <option value="category2">岗位类别2</option> &ndash;&gt;-->
<!--            <option v-for="titleItem in newTiele" :value="titleItem">-->
<!--              {{ titleItem }}-->
<!--            </option>-->
<!--          </select>-->
<!--          <select v-model="selectedCity">-->
<!--            <option value="all">请选择工作城市</option>-->
<!--            <option v-for="cityItem in newCity" :value="cityItem">-->
<!--              {{ cityItem }}-->
<!--            </option>-->
<!--          </select>-->

<!--          <button @click="filterJobs" class="btn1">-->
<!--            <i class="iconfont icon-zaicitijiao" style="font-size: 8px"></i>-->
<!--            重置-->
<!--          </button>-->
<!--        </div>-->
<!--        &lt;!&ndash; 标题 &ndash;&gt;-->
<!--        <div class="job-info1">-->
<!--          <span>职位名称</span>-->
<!--          <span>职位类别</span>-->
<!--          <span>工作城市</span>-->
<!--          <span>发布时间</span>-->
<!--        </div>-->
<!--        &lt;!&ndash; 内容 &ndash;&gt;-->
<!--        <div v-if="filteredJobs.length > 0">-->
<!--          <div-->
<!--            v-for="(job, index) in filteredJobs"-->
<!--            :key="index"-->
<!--            class="job-item"-->
<!--          >-->
<!--            &lt;!&ndash; 标题 &ndash;&gt;-->
<!--            <div class="job-info">-->
<!--              &lt;!&ndash; <img src="https://download.hecoos.com/enlightv/2025-16/f8e8a005e173c743b265a666cdd31466.png" class="ss11" /> &ndash;&gt;-->

<!--              <span class="job-name">{{ job.title }}</span>-->
<!--              <span class="job-category job-center">{{ job.type_name }}</span>-->
<!--              <span class="job-city job-center">{{ job.city }}</span>-->
<!--              <span class="job-time job-center">{{ job.create_time }}</span>-->
<!--              &lt;!&ndash; top: 10px; &ndash;&gt;-->
<!--              <span-->
<!--                @click="toggleExpand(job.id)"-->
<!--                style="-->
<!--                  color: #1a90ff;-->
<!--                  width: auto;-->
<!--                  position: absolute;-->
<!--                  right: 20px;-->
<!--                "-->
<!--                class="ss"-->
<!--              >-->
<!--                {{ job.isExpanded ? "收起详情" : "查看详情" }}</span-->
<!--              >-->
<!--              <i-->
<!--                v-if="job.isExpanded"-->
<!--                class="el-icon-arrow-up"-->
<!--                style="-->
<!--                  font-size: 8px;-->
<!--                  position: absolute;-->
<!--                  right: 10px;-->
<!--                  top: 9px;-->
<!--                "-->
<!--              ></i>-->
<!--              <i-->
<!--                v-else-->
<!--                class="el-icon-arrow-down"-->
<!--                style="-->
<!--                  font-size: 8px;-->
<!--                  position: absolute;-->
<!--                  right: 10px;-->
<!--                  bottom: 16px;-->
<!--                  top: 10px;-->
<!--                "-->
<!--              ></i>-->
<!--            </div>-->
<!--            &lt;!&ndash; 详情 &ndash;&gt;-->
<!--            <div v-show="job.isExpanded" class="job-details">-->
<!--              <h2>-->
<!--                欢迎投递简历至:-->
<!--                <span style="color: #1990ff">hr@enlightv.com</span>-->
<!--              </h2>-->
<!--              <h3>岗位职责：</h3>-->
<!--              <div-->
<!--                class="job_hole"-->
<!--                v-html="job.duty"-->
<!--                style="-->
<!--                  font-size: 14px;-->
<!--                  color: white !important;-->
<!--                  line-height: 22px !important;-->
<!--                "-->
<!--              ></div>-->
<!--              <h3>任职要求：</h3>-->
<!--              <div-->
<!--                class="job_hole"-->
<!--                v-html="job.condition"-->
<!--                style="-->
<!--                  font-size: 14px;-->
<!--                  color: white !important;-->
<!--                  line-height: 22px !important;-->
<!--                "-->
<!--              ></div>-->
<!--              <h3>福利待遇：</h3>-->
<!--              <div v-html="job.welfare" class="job_hole"></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; 无内容显示 &ndash;&gt;-->
<!--        <div v-else class="no_data">暂无岗位</div>-->
<!--      </div>-->
<!--    </div>-->
    <myFooter />
  </div>
</template>
<script>
import myHeader from "@/components/mobile/myHeader.vue";
import myFooter from "@/components/mobile/myFooter.vue";
import { getJobList, getContactUs } from "@/api/api";
import { Message } from "element-ui";

export default {
  data() {
    return {
      isShow: false,
      jobs: [],
      newTiele: [],
      newCity: [],
      postData: {},
      formData: {
        name: "",
        phone: "",
        email: "",
        content: "",
      },
      contactInfos: [
        { type: "邮箱", value: "info@enlightv.com" },
        { type: "咨询热线", value: "400-600-1196（7x24小时）" },
        { type: "公司直机", value: "010-53608556（工作日 9:00-18:00）" },
        { type: "QQ交流群", value: "794369725" },
        { type: "微信咨询", value: "hecoos studio" },
      ],
      selectedCategory: "all",
      selectedCity: "all",
      // selectedTime: "",
    };
  },
  components: { myHeader, myFooter },
  mounted() {},
  computed: {
    filteredJobs() {
      // console.log(this.filteredJobs);

      return this.jobs.filter((job) => {
        const categoryMatch =
          this.selectedCategory === "all" ||
          job.title === this.selectedCategory;
        const cityMatch =
          this.selectedCity === "all" || job.city === this.selectedCity;
        return categoryMatch && cityMatch;
      });
    },
  },
  created() {
    this.getJobInfo();
  },
  methods: {
    filterJobs() {
      this.selectedCategory = "all";
      this.selectedCity = "all";
      // this.selectedTime = "";
    },
    toggleExpand(jobId) {
      const job = this.jobs.find((item) => item.id === jobId);
      if (job) {
        job.isExpanded = !job.isExpanded;
      }
    },
    // 提交联系我们信息
    handleSubmit() {
      if (!this.formData.name) {
        Message.error("请输入你的姓名");
        return;
      }
      // 新增对 email 格式的校验
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!this.formData.email) {
        Message.error("请输入邮箱地址");
        return;
      } else if (!emailRegex.test(this.formData.email)) {
        Message.error("请输入有效的邮箱地址");
        return;
      }
      if (!this.formData.content) {
        Message.error("请输入留言内容");
        return;
      }

      let postData = {
        ...this.formData,
      };
      getContactUs(postData).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          Message.success(res.message);
          this.formData = {};
        } else {
          Message.error(res.message);
        }
      });
    },
    // 获取招聘信息
    getJobInfo() {
      let postData = {
        limit: "10",
      };
      getJobList(postData).then((res) => {
        this.jobs = res.data;
        // 使用 forEach 遍历 jobs 数组并添加 isExpanded 属性
        this.jobs.forEach((job) => {
          this.$set(job, "isExpanded", false);
        });
        console.log(this.jobs);

        this.newTiele = this.jobs
          .map((item) => item.title)
          .filter((title, index, array) => {
            return array.indexOf(title) === index;
          });
        this.newCity = this.jobs
          .map((item) => item.city)
          .filter((city, index, array) => {
            return array.indexOf(city) === index;
          });
        // console.log(this.newCity);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
  .backgro {
    background-color: black;
    background-image: url("https://download.hecoos.com/enlightv/2025-16/f4e4dfaf47dbcd0a46890b3113d35f46.PNG");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 36vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
      z-index: 1;
    }
  }

  .backgro1 {
    background-color: black;
    background-image: url("https://download.hecoos.com/enlightv/2025-16/441305c8b734ffc58f538c57cbb6bb46.PNG");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 120% 150%;
    width: 100%;
    height: 400px;
    padding: 30px 0;
    display: flex;
    align-items: center;
  }

  .backgro2 {
    background-color: black;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 100%;
    padding: 30px 0;
  }

  .bg66 h1 {
    font-size: 24px;
    font-weight: 700;
    line-height: 50px;
    color: rgba(255, 255, 255, 1);
    text-align: left;
    vertical-align: top;
  }

  .btn1 {
    background-color: #147cf5;
    padding: 4px 30px !important;
    border-radius: 5px !important;
    color: white;
    transition: all 0.5s ease;
    cursor: pointer;
    border: none;
    font-size: 18px !important;
  }

  .btn1:hover {
    background-color: blue;
  }

  .ss11 {
    width: 12px;
    height: 12px;
    position: relative;
    top: 3px;
  }

  .bg66 p {
    font-weight: 500;
    font-size: 14px;
    font-family: YourFontName2;

    color: rgba(255, 255, 255, 1);
    text-align: left;
    vertical-align: top;
  }

  .padd {
    background: #161616;
    padding: 30px 43px;
  }

  .posi {
    font-size: 20px;
    z-index: 99;
    width: 100%;
  }
  .posi_h3 {
    font-size: 45px !important;
  }

  .posit2 {
    text-align: center;
    font-size: 20px;
    color: white;
  }

  .posi p {
    font-size: 18px !important;
    font-weight: 700;
    line-height: 25px !important;
    color: rgba(255, 255, 255, 1);
    vertical-align: top;
    font-family: YourFontName2;
    padding: 0px 43px;
  }

  .posih1 span {
    background: linear-gradient(
      to left,
      rgba(113, 77, 255, 1),
      rgba(156, 131, 255, 1),
      rgba(225, 81, 255, 1),
      rgba(255, 247, 89, 1)
    );
    /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
    background-clip: text;
    /*将设置的背景颜色限制在文字中*/
    -webkit-text-fill-color: transparent;
    /*给文字设置成透明*/
  }

  .posih1 {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: -0.89px;
    line-height: 89px;
    color: rgba(255, 255, 255, 1);
    text-align: left;
    vertical-align: middle;
    padding-bottom: 100px;
    padding: 0px 43px;
  }

  .clearfix {
    background-color: black;
  }

  .formtest {
    padding: 30px 0;
  }

  .right {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .form-group {
    margin-bottom: 15px;
    padding: 0px 43px;
  }

  .form-input,
  .form-textarea {
    background-color: #24272a;
    color: #fff;
    border: 0.5px solid white;
    width: 100%;
    padding: 20px 10px !important;
    font-size: 18px !important;
  }

  input::placeholder,
  textarea::placeholder {
    font-size: 18px !important;
    color: white;
    /* 将提示文字颜色改为浅灰色，可根据需求调整颜色值 */
  }

  .form-textarea {
    min-height: 63px;
  }

  .button-container {
    text-align: right;

    margin-top: 30px;
  }

  .send-button1 {
    padding: 5px 10px;
    background-color: #147cf5;
    color: white;
    border: none;
    font-size: 10px;
    transition: all 1s ease;
    cursor: pointer;
    width: 180px !important;
    height: 50px !important;
    font-size: 18px !important;
  }

  .send-button1:hover {
    background-color: blue;
    color: white;
  }

  .righttext {
    height: 100%;
    padding: 20px;
    width: 400px;
    margin-bottom: 30px;
    margin-left: 100px;
    padding-bottom: 50px;
    background-color: #24272a;
    color: white;
    border: 1px solid red;
  }

  .send-btn-container {
    padding: 10px 0px 200px 200px;
  }

  .send-button {
    padding: 10px 20px;
    background: linear-gradient(90deg, #00b4ff, #007bff);
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }

  .job-list-container {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url("../../../asset/mobile/mobile_CaseDemonstration/image-2.png");
    h1 {
      font-size: 45px !important;
    }
    p {
      font-size: 18px !important;
    }
  }

  .filter-section {
    margin: 10px 0;
  }

  select {
    font-size: 18px !important;
    color: gray;
    border: none;
    padding: 2px 5px;
    border-radius: 3px;
    margin-right: 5px;
  }

  .job-item {
    background-color: #212121;
    padding: 5px 2px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    color: #7b7b7b;
    font-size: 16px;
    border-radius: 5px;
    flex-direction: column;
    /* 使子元素垂直排列，实现详情另起一行 */
    align-items: flex-start;
    position: relative;
  }
  .job-info1 {
    padding: 10px 0;
  }
  .job-info1 span {
    width: 120px !important;
    display: inline-block;
    font-size: 20px !important;
    color: white;
    text-align: left;
  }
  .job-info {
    .ss {
      position: absolute !important;
      right: -15px !important;
    }
    i {
      font-size: 18px !important;
    }
  }
  .job-info span {
    display: inline-block;
    width: 120px !important;
    font-size: 18px !important;
    padding: 2px 0px;
    text-align: left;
  }
  .job-info span:last-child {
    width: 50px !important;
  }

  .job-actions {
    text-align: right;
    color: #409eff;
    cursor: pointer;
  }

  .job-details {
    margin-top: 10px;
    padding: 10px;
    border-top: 1px solid #ccc;
    width: 100%;
    height: auto;
    background-color: #212121;
  }

  .job-details h2 {
    font-size: 18px !important;
    color: white;
  }

  .job-details h3 {
    border-left: 2px solid #1990ff;
    color: white;
    padding-left: 5px;
    margin: 10px 0;
    font-size: 15px !important;
  }

  .app {
    background-color: #161616;
    color: #fff;
    padding: 30px 0px;
    font-weight: 0;
  }

  .ssssss {
    display: inline-block;
    font-size: 18px !important;
    width: 150px !important;
    letter-spacing: 0.5px;
    line-height: 27.44px;
    color: rgba(255, 255, 255, 1);
    font-family: YourFontName2;
    padding: 0px 0px 0px 43px;
  }

  .s1 {
    font-size: 18px !important;
    font-family: YourFontName2;
  }

  .title {
    font-size: 45px !important;
    font-weight: 700;
    padding: 0px 43px;
    color: rgba(255, 255, 255, 1);
    text-align: left;
    vertical-align: top;
  }

  .description {
    font-size: 20px !important;
    font-family: YourFontName2;
    padding: 15px 43px;
  }

  .job-name {
    font-size: 10px;
    color: white;
    font-family: YourFontName3;
  }
}
.backgro {
  background-color: black;
  background-image: url("https://download.hecoos.com/enlightv/2025-16/f4e4dfaf47dbcd0a46890b3113d35f46.PNG");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 36vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
}

.backgro1 {
  background-color: black;
  background-image: url("https://download.hecoos.com/enlightv/2025-16/441305c8b734ffc58f538c57cbb6bb46.PNG");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 120% 150%;
  width: 100%;
  padding: 30px 0;
}

.backgro2 {
  background-color: black;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  padding: 30px 0;
}

.bg66 h1 {
  font-size: 24px;
  font-weight: 700;
  line-height: 50px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}

.btn1 {
  background-color: #147cf5;
  padding: 3.1px 5px;
  border-radius: 5px;
  color: white;
  transition: all 0.5s ease;
  cursor: pointer;
  border: none;
  font-size: 10px;
}

.btn1:hover {
  background-color: blue;
}

.ss11 {
  width: 12px;
  height: 12px;
  position: relative;
  top: 3px;
}

.bg66 p {
  font-weight: 500;
  font-size: 14px;
  font-family: YourFontName2;

  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}

.padd {
  background: #161616;
  padding: 30px 43px;
}

.posi {
  font-size: 20px;
  z-index: 99;
  width: 100%;
}

.posit2 {
  text-align: center;
  font-size: 20px;
  color: white;
}

.posi p {
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  color: rgba(255, 255, 255, 1);

  vertical-align: top;
  font-family: YourFontName2;
  padding: 0px 43px;
}

.posih1 span {
  background: linear-gradient(
    to left,
    rgba(113, 77, 255, 1),
    rgba(156, 131, 255, 1),
    rgba(225, 81, 255, 1),
    rgba(255, 247, 89, 1)
  );
  /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
  background-clip: text;
  /*将设置的背景颜色限制在文字中*/
  -webkit-text-fill-color: transparent;
  /*给文字设置成透明*/
}

.posih1 {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.89px;
  line-height: 89px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: middle;
  padding-bottom: 100px;
  padding: 0px 43px;
}

.clearfix {
  background-color: black;
}

.formtest {
  padding: 30px 0;
}

.right {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.form-group {
  margin-bottom: 15px;
  padding: 0px 43px;
}

.form-input,
.form-textarea {
  background-color: #24272a;
  color: #fff;
  border: 0.5px solid white;
  width: 100%;
  padding: 5px 10px;
}

input::placeholder,
textarea::placeholder {
  font-size: 10px;
  color: white;
  /* 将提示文字颜色改为浅灰色，可根据需求调整颜色值 */
}

.form-textarea {
  min-height: 63px;
}

.button-container {
  text-align: right;

  margin-top: 30px;
}

.send-button1 {
  padding: 5px 10px;
  background-color: #147cf5;
  color: white;
  border: none;
  font-size: 10px;
  transition: all 1s ease;
  cursor: pointer;
}

.send-button1:hover {
  background-color: blue;
  color: white;
}

.righttext {
  height: 100%;
  padding: 20px;
  width: 400px;
  margin-bottom: 30px;
  margin-left: 100px;
  padding-bottom: 50px;
  background-color: #24272a;
  color: white;
  border: 1px solid red;
}

.send-btn-container {
  padding: 10px 0px 200px 200px;
}

.send-button {
  padding: 10px 20px;
  background: linear-gradient(90deg, #00b4ff, #007bff);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.job-list-container {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("../../../asset/mobile/mobile_CaseDemonstration/image-2.png");
}

.filter-section {
  margin: 10px 0;
}

select {
  font-size: 10px;
  color: gray;
  border: none;
  padding: 2px 5px;
  border-radius: 3px;
  margin-right: 5px;
}

.job-item {
  background-color: #212121;
  padding: 5px 2px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  color: #7b7b7b;
  font-size: 16px;
  border-radius: 5px;
  flex-direction: column;
  /* 使子元素垂直排列，实现详情另起一行 */
  align-items: flex-start;
  position: relative;
}
.job-info1 {
  margin-bottom: 8px;
}
.job-info1 span {
  width: 20%;
  display: inline-block;
  font-size: 12px;
  color: white;
  text-align: left;
}
.job-item .job-info {
  width: 100%;
  display: flex;
  align-items: center;
  // justify-content: center;
}
.job-info span {
  display: inline-block;
  width: 20%;
  font-size: 10px;
  padding: 2px 0px;
  text-align: left;
}

.job-actions {
  text-align: right;
  color: #409eff;
  cursor: pointer;
}

.job-details {
  margin-top: 10px;
  padding: 10px;
  border-top: 1px solid #ccc;
  width: 100%;
  height: auto;
  background-color: #212121;
}

.job-details h2 {
  font-size: 10px;
  color: white;
}

.job-details h3 {
  border-left: 2px solid #1990ff;
  color: white;
  padding-left: 5px;
  margin: 10px 0;
  font-size: 10px;
}

.app {
  background-color: #161616;
  color: #fff;
  padding: 30px 0px;
  font-weight: 0;
}

.ssssss {
  display: inline-block;
  font-size: 12px;
  width: 120px;
  letter-spacing: 0.5px;
  line-height: 27.44px;
  color: rgba(255, 255, 255, 1);
  font-family: YourFontName2;
  padding: 0px 0px 0px 43px;
}

.s1 {
  font-size: 12px;
  font-family: YourFontName2;
}
.title {
  font-size: 24px;
  font-weight: 700;
  padding: 0px 43px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}

.description {
  font-size: 12px;
  font-family: YourFontName2;
  padding: 15px 43px;
  line-height: 20px;
}

.job-name {
  font-size: 10px;
  color: white;
  font-family: YourFontName3;
}
</style>
<style>
.job-item .job_hole {
  color: #fff !important;
}

.job-item .job_hole p {
  font-size: 9px !important;
  color: #fff !important;
  font-family: YourFontName2 !important;
  line-height: 15px !important;
}

.job-item .job_hole span {
  color: #fff !important;
  font-size: 9px !important;
  font-family: YourFontName2 !important;
  line-height: 15px !important;
}

.clear_she {
  width: 20px !important;
}

.flowing-gradient-text {
  font-size: 80px !important;
  --k: 0;
  place-self: center;
  background: linear-gradient(
    90deg,
    hsl(calc(var(--k) * 1turn), 95%, 65%),
    hsl(calc(var(--k) * 1turn + 90deg), 95%, 65%)
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font: 900 clamp(0.875em, 7.25vw, 5em) arial black, sans-serif;
  text-align: center;
  /* text-transform: uppercase; */
  animation: k 4s linear infinite;
  font-family: "YourFontName";
}

@property --k {
  syntax: "<number>";
  initial-value: 0;
  inherits: false;
}

@keyframes k {
  to {
    --k: 1;
  }
}

@media screen and (min-width: 768px) {
  .job-item .job_hole {
    color: #fff !important;
  }

  .job-item .job_hole p {
    font-size: 15px !important;
    color: #fff !important;
    font-family: YourFontName2 !important;
    line-height: 20px !important;
  }

  .job-item .job_hole span {
    color: #fff !important;
    font-size: 15px !important;
    font-family: YourFontName2 !important;
    line-height: 20px !important;
  }

  .clear_she {
    width: 20px !important;
  }

  .flowing-gradient-text {
    font-size: 80px !important;
    --k: 0;
    place-self: center;
    background: linear-gradient(
      90deg,
      hsl(calc(var(--k) * 1turn), 95%, 65%),
      hsl(calc(var(--k) * 1turn + 90deg), 95%, 65%)
    );
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    font: 900 clamp(0.875em, 7.25vw, 5em) arial black, sans-serif;
    text-align: center;
    /* text-transform: uppercase; */
    animation: k 4s linear infinite;
    font-family: "YourFontName";
  }

  @property --k {
    syntax: "<number>";
    initial-value: 0;
    inherits: false;
  }

  @keyframes k {
    to {
      --k: 1;
    }
  }
}
</style>
